// extracted by mini-css-extract-plugin
export var copy = "footer-module--copy--vLGY+";
export var followLink = "footer-module--follow-link--oOoY9";
export var layoutFooter = "footer-module--layout-footer--EUWg2";